<template>
  <div class="content">
    <div class="heaad">
      <detail-item :title="'订单编号'" :value="order.order_no"></detail-item>
    </div>
    <div class="list">
      <detail-item :title="'采购数量'" :value="order.num + '台'"></detail-item>
      <detail-item :title="'收货人'" :value="order.receiver"></detail-item>
      <detail-item :title="'联系方式'" :value="order.mobile"></detail-item>
      <detail-item :title="'收货地址'" :value="order.province + '' + order.city + '' + order.district + '' + order.address"></detail-item>
      <detail-item v-if="order.type == 0" :title="'退押金账号'" :value="order.sc_account"></detail-item>
      <detail-item :title="'提交时间'" :value="order.created_at"></detail-item>
      <detail-item :title="'支付状态'" :value="order.pay_state_cn"></detail-item>
      <detail-item v-if="order.pay_state == '1'" :title="'支付时间'" :value="order.pay_time"></detail-item>
      <detail-item :title="'支付金额'" :value="order.amount"></detail-item>
      <detail-item :title="'订单状态'" :value="order.state_cn"></detail-item>
      <detail-item v-if="order.express_no" :title="'运单号'" :value="order.express_no"></detail-item>
    </div>
    <div v-if="order.pay_state == '0' && order.state_cn !== '已取消'" class="bottom">
      <!-- <button class="clear" @click="clear">取消订单</button> -->
      <button class="pay" @click="topay">去支付 <span></span></button>
    </div>
  </div>
</template>
<script>
import detailItem from '@/components/detail_item'
import bus from '../../assets/js/eventBus'
import _wx from '../../../static/js/chelun-wx-1.1.js'
import { baseUrl } from '../../http/env.js'
import { getOrderByNo } from '@/http/api'
export default {
  data () {
    return {
      order: {},
      order_no: ''
    }
  },
  components: {
    'detail-item': detailItem
  },
  methods: {
    getOrderByNo () {
      getOrderByNo({ order_no: this.order_no }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.order = res.data
        }
      })
    },
    topay () {
      console.log(`${baseUrl}/agt/pay/get_openid`)
      let pay = {
        order_no: this.order.order_no,
        serialnumber: this.order.serial_number,
        amount: this.order.amount,
        channel_uid: this.$route.query.channel_uid,
        channel_no: this.$route.query.channel_no,
        id: this.order.id
      }
      localStorage.setItem('pay', JSON.stringify(pay))
      if (_wx.isWx) {
        window.location.href = `${baseUrl}/agt/pay/get_openid`
      } else {
        this.channel = 'alipay'
        this.$router.push({
          path: '/pay'
        })
      }
    },
    clear () {
      // 取消订单
    }
  },
  mounted () {
    let order = this.$route.params.order
    let order_no = this.$route.params.id
    console.log('123' + order)

    this.order_no = order_no
    if (!order) {
      this.getOrderByNo()
    } else {
      this.order = JSON.parse(order)
    }
  },
  beforeDestroy () {
    localStorage.setItem('order', JSON.stringify(this.order))
  },
  destroyed () {
    bus.$emit('serialnumber', {
      amount: this.order.amount,
      serialnumber: this.order.serial_number
    })
  }
}
</script>
<style lang="scss" scoped>
.content {
  background: #f5f5f5;
  font-size: 0;
  .heaad {
    padding: 0 .3rem;
    background: #fff;
    margin-bottom: .2rem;
    .item {
      height: 1rem;
      line-height: 1rem;
    }
  }
  .list {
    background: #fff;
    padding: 0 .3rem;
  }
  .bottom {
    padding: 0 .3rem;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.3rem;
    background: #fff;
    box-shadow: 0px -3px 26px 0px rgba(200, 200, 200, 0.25);
    .clear {
      width: 2.40rem;
      height: .90rem;
      margin-top: .2rem;
      border-radius: .10rem;
      color: #02B389;
      border: 2px solid rgba(2, 179, 137, 1);
      background: none;
    }
    .pay {
      float: right;
      color: #fff;
      margin-top: .2rem;
      margin-left: .20rem;
      width: 6.90rem;
      height: .90rem;
      background: rgba(2, 179, 137, 1);
      border-radius: .10rem;
      font-size: .32rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderdetail/Orderdetail.vue